/* eslint-disable no-console */
import { MutationTree } from 'vuex';
import { AppSignInResponse } from '@/services/nexus-auth.service';
import { AuthState, UserProfile } from './state';

// eslint-disable-next-line no-shadow
export const enum MutationTypes {
  LOGIN_ANON = '🐱‍👤✔ Login Anonymous',
  LOGIN_ERROR = '🔐❌ Login Error',
  LOGIN_USER = '😎✔ Login User',
  SIGNUP = '🔏📧✔ Confirmation Email Sent',
  SIGNUP_ERROR = '🔏❌ Signup Error',
  LOGOUT = '👋✔ Logged Out',
  LOGOUT_ERROR = '👋❌Log Out failed',
  CONFIRMED_USER = '🔍👤 Confirmed User',
  CONFIRMATION_ERROR = '🔍❌ User Confirmation Failed',
  PASSWORD_RESET = '🔃🔒 Password Reset',
  PASSWORD_RESET_ERROR = '🔃🔒❌ Password Reset Error',
  AUTH_START = 'AUTH_START',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_FAILURE = 'AUTH_FAILURE',
  CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE'
}

export const mutations: MutationTree<AuthState> = {
  [MutationTypes.AUTH_START](state) {
    state.loading = true;
    state.error = null;
  },

  [MutationTypes.AUTH_SUCCESS](state, payload: AppSignInResponse) {
    if (payload.user && payload.accessToken) {
      state.user = payload.user as UserProfile;
      state.accessToken = payload.accessToken;
      state.isAuthenticated = true;
    } else {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.error = 'Authentication successful but user data or token missing.';
    }
    state.loading = false;
    state.error = null;
  },

  [MutationTypes.AUTH_FAILURE](state, errorMessage: string) {
    state.user = null;
    state.accessToken = null;
    state.isAuthenticated = false;
    state.error = errorMessage;
    state.loading = false;
  },

  [MutationTypes.CLEAR_AUTH_STATE](state) {
    state.user = null;
    state.accessToken = null;
    state.isAuthenticated = false;
    state.error = null;
    state.loading = false;
  },

  [MutationTypes.LOGIN_ANON](state, userPayload: UserProfile) {
    state.user = userPayload;
    state.isAuthenticated = !!userPayload;
    state.loading = false;
    state.error = null;
  },

  [MutationTypes.LOGIN_USER](state, response: AppSignInResponse) {
    if (response.success && response.user && response.accessToken) {
      state.user = response.user as UserProfile;
      state.accessToken = response.accessToken;
      state.isAuthenticated = true;
      state.error = null;
    } else {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.error = response.message || 'Login failed to provide complete data.';
    }
    state.loading = false;
  },

  [MutationTypes.LOGIN_ERROR](state, errorCode: string) {
    state.user = null;
    state.accessToken = null;
    state.isAuthenticated = false;
    state.error = errorCode;
    state.loading = false;
    console.error('Login Error:', errorCode);
  },

  [MutationTypes.LOGOUT](state) {
    state.user = null;
    state.accessToken = null;
    state.isAuthenticated = false;
    state.error = null;
    state.loading = false;
    console.log('User logged out, state cleared.');
  },

  [MutationTypes.SIGNUP_ERROR](state, errorCode: string) {
    state.error = errorCode;
    state.loading = false;
    console.error('Signup Error:', errorCode);
  },

  [MutationTypes.SIGNUP]: state => {
    state.loading = false;
  },

  [MutationTypes.LOGOUT_ERROR](state, errorCode: string) {
    state.error = errorCode;
    state.loading = false;
    console.error('Logout Error:', errorCode);
  },

  [MutationTypes.CONFIRMED_USER]: state => {
    state.loading = false;
  },

  [MutationTypes.CONFIRMATION_ERROR](state, errorCode: string) {
    state.error = errorCode;
    state.loading = false;
    console.error('Confirmation Error:', errorCode);
  },

  [MutationTypes.PASSWORD_RESET]: state => {
    state.loading = false;
  },

  [MutationTypes.PASSWORD_RESET_ERROR](state, errorCode: string) {
    state.error = errorCode;
    state.loading = false;
    console.error('Password Reset Error:', errorCode);
  }
};
